import React from 'react'
import styles from './SelectableCard.module.scss'

interface SelectableCardProps {
    selected?: boolean
    disabled?: boolean
    onClick?: () => void
    className?: string
    children: React.ReactNode
}

export const SelectableCard: React.FC<SelectableCardProps> = ({
    selected = false,
    disabled = false,
    onClick,
    className = '',
    children,
}) => {
    return (
        <div
            className={`${styles.selectableCard} ${selected ? styles.selected : ''} ${disabled ? styles.disabled : ''} ${className}`}
            onClick={disabled ? undefined : onClick}
            role={onClick ? 'button' : undefined}
            tabIndex={onClick && !disabled ? 0 : undefined}
            onKeyDown={onClick && !disabled ? (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    onClick()
                }
            } : undefined}
        >
            {children}
        </div>
    )
}
